import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { View360Response } from '@compiere-ws/models/apiz-domains';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class View360DataService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = environment.config.backend.ws.url;

  getCustomer360Details<T extends View360Response>(customerId: number): Observable<T> {
    return this.http.get<T>(this.getUrl(`view-360/customer/${customerId}`));
  }

  getVendor360Details<T extends View360Response>(customerId: number): Observable<T> {
    return this.http.get<T>(this.getUrl(`view-360/vendor/${customerId}`));
  }

  private getUrl(endpoint?: string): string {
    if (endpoint) {
      return `${this.baseUrl}/${endpoint}`;
    }

    return this.baseUrl;
  }
}
